import { GenericLazyString } from '@eventbrite/i18n';
import React, { FunctionComponent } from 'react';

export interface PriceInformationProps {
    price: GenericLazyString | string | null;
    /**
     * The string representing the associated fees and taxes. Should include the appropriate
     * copy. If not included, the section will not be rendered.
     **/
    feeAndTax: Array<GenericLazyString | string> | null;
    /**
     * Represents the original cost of the ticket prior to discounts applied
     **/
    primaryPrice: GenericLazyString | string | null;
}

export const PriceInformation: FunctionComponent<PriceInformationProps> = ({
    price,
    feeAndTax,
    primaryPrice,
}) => {
    const feeAndTaxContent = feeAndTax
        ? feeAndTax.map((item, index) => (
              <span
                  key={index}
                  data-spec="fee-information"
                  data-testid="fee-information"
                  className="eds-text-bs eds-ticket-card-content__fee-information eds-l-pad-right-1"
              >
                  {item}
              </span>
          ))
        : null;

    const primaryPriceContent = primaryPrice ? (
        <span
            className="eds-text--strikethrough eds-l-pad-left-1"
            data-testid="primary-price"
        >
            {primaryPrice}
        </span>
    ) : null;

    return (
        <div
            className="ticket-card__price-information"
            data-spec="price-information"
            data-testid="price-information"
        >
            <span className="ticket-price">
                {price}
                {primaryPriceContent}
            </span>
            {feeAndTaxContent}
        </div>
    );
};

export default PriceInformation;
